module.exports = new __parcel__URL__("meteor-icon.9417010c.png").toString();